"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP_PATCH = exports.HTTP_DELETE = exports.HTTP_PUT = exports.HTTP_POST = exports.HTTP_GET = void 0;
/**
 * HTTP request methods
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
 * for list of methods and their meanings
 */
exports.HTTP_GET = "GET";
exports.HTTP_POST = "POST";
exports.HTTP_PUT = "PUT";
exports.HTTP_DELETE = "DELETE";
exports.HTTP_PATCH = "PATCH";
//# sourceMappingURL=request-methods.js.map